import React, { useState } from "react";
import { useForm } from 'react-hook-form';
import {useDispatch, useSelector} from "react-redux";
import Spinner from "../Spinner.js";
import {validateCoupon} from "../../actions/discount";
import {setTotalPrice} from "../../actions/price";

export default function CouponCode() {
    const [processing, setProcessing] = useState(false);
    const [submitFailed, setSubmitFailed] = useState(false);
    const dispatch = useDispatch();
    const price = useSelector(state => state.price);
    const discount = useSelector(state => state.discount);

    const { register, handleSubmit, formState: { errors } } = useForm();

    // The applied coupon lives in Redux, so it survives closing and reopening
    // this section (the Disclosure panel unmounts on close). The price is
    // adjusted exactly once, in onSubmit when validation succeeds - never on
    // mount - so reopening the section can't apply the discount again.
    const appliedCoupon = discount && !discount.error ? discount : null;

    const onSubmit = async (data, e) => {
        e.preventDefault();

        // Only one coupon per booking.
        if (appliedCoupon || processing) {
            return;
        }

        setProcessing(true);
        setSubmitFailed(false);

        const res = await dispatch(validateCoupon(data));

        if (res && res.coupon && !res.coupon.error) {
            const { amount, isFixed } = res.coupon;
            const discounted = isFixed ? price - amount : price - (price * amount / 100);
            dispatch(setTotalPrice(Math.max(0, discounted)));
        } else {
            setSubmitFailed(true);
        }

        setProcessing(false);
    };

    return (
        <div className="col-span-6 sm:col-span-3">
            <form onSubmit={handleSubmit(onSubmit)}>
                <input
                    type="text"
                    className="focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md disabled:bg-gray-100"
                    placeholder="Rabattkod"
                    disabled={!!appliedCoupon}
                    {...register("couponcode", {required: !appliedCoupon, maxLength: 20})}
                />
                {errors?.couponcode && !appliedCoupon && (<p className="mt-2 text-sm text-red-600">Rabattkod måste anges.</p>)}
                {submitFailed && !processing && !appliedCoupon && (<p className="mt-2 text-sm text-red-600">Rabattkod ej giltig.</p>)}
                {appliedCoupon && (
                    <p className="mt-2 text-sm text-green-600">
                        Rabattkod "{appliedCoupon.code}" applicerad. Rabatt: {appliedCoupon.amount}{appliedCoupon.isFixed ? 'kr' : '%'}.
                        Endast en rabattkod per bokning.
                    </p>
                )}
                <button
                    className="mt-4 inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:bg-gray-400"
                    disabled={processing || !!appliedCoupon}
                    id="submit"
                >
                    <span id="button-text">
                      {processing ? (
                          <Spinner />
                      ) : (
                          "Verifiera"
                      )}
                    </span>
                </button>
            </form>
        </div>
    );
}
